/* Cosmeceutical Solutions - Wholesale Order Form + header CTA
   0. Header CTA (runs on EVERY page - see the second block at the bottom).
   1. Login gate: anyone not signed in is sent to /account/login.
   2. Skin: matches the app's UI to the site design system (Newsreader / Mulish,
      navy #192846, cream #FFFAF8, hairline #E6DFD2). The app's own stylesheet is
      served cross-origin, so these are overrides.
   3. Range buttons above the product table. The WSH order form supports one URL
      per collection (/apps/shop/<handle>), so they are plain links - they do not
      depend on the app's internal markup. If a handle is renamed the link falls
      back to the full list.

   Self-contained: injects its own CSS, needs no stylesheet.
   Scoped to /apps/shop - nothing else on the site is touched. */
(function () {
  if (location.pathname.indexOf('/apps/shop') !== 0) return;

  /* ---- 1. login gate -------------------------------------------------- */
  if (!(window.__st && window.__st.cid)) {
    document.documentElement.style.visibility = 'hidden';
    location.replace('/account/login');
    return;
  }

  /* ---- 2. skin -------------------------------------------------------- */
  function skin() {
    if (document.getElementById('cs-wof-skin')) return;
    var st = document.createElement('style');
    st.id = 'cs-wof-skin';
    st.textContent =
      '#wof_order_from_main_container,#wof_order_from_main_container *:not(i):not(svg){font-family:\'Mulish\',system-ui,sans-serif;}' +
      '[id*="__notification-banner"]{display:none !important;}' +
      '#wof_tab_container .wof-tabs,#wof_tab_container .wof-tabs span{font-family:\'Newsreader\',Georgia,serif !important;font-weight:500 !important;font-size:40px !important;line-height:1.1 !important;color:#192846 !important;letter-spacing:0 !important;}' +
      '@media (max-width:749px){#wof_tab_container .wof-tabs,#wof_tab_container .wof-tabs span{font-size:30px !important;}}' +
      '.custom-wholesale-nav a.button{font-size:12.5px !important;font-weight:600 !important;letter-spacing:.05em !important;border-radius:2px !important;}' +
      '#wof_filter_button_wrapper,#wof_sort_by_button_wrapper,#wof_cart_widget_wrapper{border:1px solid #E6DFD2 !important;border-radius:2px !important;background:#fff !important;}' +
      '#lbl_filter,#lbl_sort_by{font-size:13px !important;font-weight:600 !important;color:#192846 !important;letter-spacing:.04em !important;}' +
      '#wof_txt_search{font-family:\'Mulish\',sans-serif !important;font-size:14px !important;border:1px solid #E6DFD2 !important;border-right:0 !important;border-radius:2px 0 0 2px !important;color:#44464A !important;}' +
      '#wof_product_table,#wof_product_table *{box-shadow:none !important;outline:none !important;}' +
      '#wof_product_table td,#wof_product_table th{border-left:0 !important;border-right:0 !important;}' +
      '#wof_product_table th{font-size:11.5px !important;font-weight:600 !important;letter-spacing:.16em !important;text-transform:uppercase !important;color:#8A8576 !important;border-bottom:1px solid #E6DFD2 !important;padding-bottom:14px !important;}' +
      '#wof_product_table td{font-size:15px !important;color:#44464A !important;padding-top:18px !important;padding-bottom:18px !important;}' +
      '#wof_product_table .wof-product-title{color:#192846 !important;font-weight:600 !important;line-height:1.45 !important;}' +
      '#wof_product_table tbody tr.product-row{border-bottom:1px solid #EAE3D6 !important;}' +
      '#wof_product_table tbody tr.product-row:hover{background:#FFFAF8 !important;}' +
      '#wof_order_from_main_container .quantity-box-wrapper{border:1px solid #E6DFD2 !important;border-radius:2px !important;}' +
      'button.wof-add-to-cart-button{font-family:\'Mulish\',sans-serif !important;font-size:12.5px !important;font-weight:600 !important;letter-spacing:.05em !important;background-color:#192846 !important;color:#FFFAF8 !important;border:1px solid #192846 !important;border-radius:2px !important;padding:12px 22px !important;}' +
      'button.wof-add-to-cart-button:hover{background-color:#2C517A !important;border-color:#2C517A !important;}';
    document.head.appendChild(st);
  }

  /* ---- 3. range buttons ----------------------------------------------- */
  var RANGES = [
    ['All products', ''],
    ['Thermoceutical retail', 'thermoceutical-retail'],
    ['Thermoceutical professional', 'thermoceutical-professional'],
    ['Celestetic retail', 'celestetic-retail'],
    ['Celestetic professional', 'celestetic-professional'],
    ['SkinB5', 'skinb5']
  ];

  function styles() {
    if (document.getElementById('cs-wof-style')) return;
    var st = document.createElement('style');
    st.id = 'cs-wof-style';
    st.textContent =
      '.cs-wof-ranges{display:flex;flex-wrap:wrap;justify-content:center;gap:10px;margin:20px 0 30px}' +
      '.cs-wof-ranges a{font-family:Mulish,sans-serif;font-size:13px;letter-spacing:.055em;' +
      'padding:11px 18px;border:1px solid #192846;background:#fff;color:#192846;' +
      'text-decoration:none;line-height:1;transition:background .2s ease,color .2s ease}' +
      '.cs-wof-ranges a:hover{background:#192846;color:#FFFAF8}' +
      '.cs-wof-ranges a[aria-current="true"]{background:#192846;color:#FFFAF8}' +
      '@media (max-width:749px){.cs-wof-ranges{gap:8px;margin:16px 0 24px}' +
      '.cs-wof-ranges a{font-size:12px;padding:10px 14px}}';
    document.head.appendChild(st);
  }

  function build() {
    var bar = document.getElementById('wof_top_bar');
    if (!bar || document.querySelector('.cs-wof-ranges')) return !!bar;
    styles();
    var here = (location.pathname.split('/apps/shop')[1] || '').replace(/^\//, '').replace(/\/+$/, '');
    var wrap = document.createElement('div');
    wrap.className = 'cs-wof-ranges';
    RANGES.forEach(function (r) {
      var a = document.createElement('a');
      a.href = '/apps/shop' + (r[1] ? '/' + r[1] : '');
      a.textContent = r[0];
      if (here === r[1]) a.setAttribute('aria-current', 'true');
      wrap.appendChild(a);
    });
    bar.parentNode.insertBefore(wrap, bar.nextSibling);
    return true;
  }

  function start() {
    skin();
    if (build()) return;
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (build() || tries > 20) clearInterval(t);
    }, 300);
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();

/* Header CTA: the theme hardcodes two buttons - "Become a Stockist" and
   "Clinic Login" - in sections/header.liquid, in 2 places each, with no
   {% if customer %} anywhere. So a partner who is already signed in still sees
   "Clinic Login" (which dumps them on the Orders page), still sees an invitation
   to become a stockist they already are, and has no way to sign out: the theme
   has no logout link on any page.

   Until those lines can be made conditional in header.liquid, this rewrites
   them client-side.

     signed out   Become a Stockist -> /pages/contact   (unchanged)
                  Clinic Login      -> /account/login   (was a hardcoded
                                       shopify.com URL; the relative route keeps
                                       the visitor on the store domain, so a
                                       theme preview session survives)

     signed in    My Account        -> /account         (orders, profile, and
                                       Shopify's own Sign out live in there)
                  Order Form        -> /apps/shop

   Shopify exposes the signed-in customer id as window.__st.cid on every page. */
(function () {
  var SIGNED_IN = !!(window.__st && window.__st.cid);

  function set(a, href, label) {
    a.setAttribute('href', href);
    if (label) a.textContent = ' ' + label + ' ';
    a.setAttribute('data-cs-header', 'done');
  }

  function apply() {
    var login = document.querySelectorAll('a.header-login-btn');
    if (!login.length) return false;

    for (var i = 0; i < login.length; i++) {
      if (login[i].getAttribute('data-cs-header') === 'done') continue;
      if (SIGNED_IN) set(login[i], '/apps/shop', 'Order Form');
      else set(login[i], '/account/login', null);
    }

    if (SIGNED_IN) {
      var stockist = document.querySelectorAll('a.header-stockist-btn');
      for (var j = 0; j < stockist.length; j++) {
        if (stockist[j].getAttribute('data-cs-header') === 'done') continue;
        set(stockist[j], '/account', 'My Account');
      }
    }
    return true;
  }

  if (!apply()) {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (apply() || tries > 30) clearInterval(t);
    }, 100);
    document.addEventListener('DOMContentLoaded', apply);
  }
})();
